import { findBalance } from "@/api/service";
const state = {
    balance: '',
}
const mutations = {
    setBalance(state, model) {
        state.balance = model
    },
}
const actions = {
    getBalanceInfo({ commit }) {
        return new Promise((resolve, reject) => {
            findBalance(0).then((res) => {
                //console.log(res)
                commit('setBalance', res || {})
                resolve(res || {})
            }).catch((err) => {
                reject(err)
            })
        })
        
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
};